import { LinhaListaContatos } from '../models/linha-lista-contatos.model';

export const PASTA_ICONES_FILTRO = './assets/icones/redesign/modulos/chat/filter';
export const TAMANHO_PAGINA = 25;
export const MAX_TAGS_VISIVEIS = 2;
export const ALTURA_ITEM_CONTATO = 88;
export const DURACAO_DESTAQUE_CONTATO_NOVO = 1600;
export const LINHAS_SKELETON_MAIS: LinhaListaContatos[] = [1, 2, 3].map(n => ({ chave: `skeleton-${n}` }));
export const TEXTO_VAZIO_CHAT = 'Não há contatos com sessão ativa para os filtros selecionados.';
export const TEXTO_VAZIO_CONTATOS = 'Não há contatos cadastrados para os filtros selecionados.';
export const DURACAO_SAIDA_CONTATO_TEMPORARIO = 1800;
